import React, { type ButtonHTMLAttributes, type ReactNode } from "react";

import styles from "./Button.module.css";

type ButtonVariant = "primary" | "secondary" | "ghost";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	fullWidth?: boolean;
	icon?: ReactNode;
	variant?: ButtonVariant;
}

export const Button = ({
	children,
	className = "",
	fullWidth = false,
	icon,
	type = "button",
	variant = "primary",
	...rest
}: ButtonProps) => {
	const classNames = [styles.button, styles[variant], fullWidth ? styles.fullWidth : "", className]
		.filter(Boolean)
		.join(" ");

	return (
		<button className={classNames} type={type === "submit" ? "submit" : "button"} {...rest}>
			{icon}
			<span>{children}</span>
		</button>
	);
};
